import { Node } from '@tiptap/core';
var Document = Node.create({
  name: 'doc',
  topNode: true,
  content: 'block+'
});
export { Document, Document as default };